// extracted by mini-css-extract-plugin
export var root = "PlasmicLatestPosts-module--root--d5c9e";
export var text__qiznh = "PlasmicLatestPosts-module--text__qiznh--303c0";